import React from 'react';

function SvgFullStar({ fill = '#d7f0e8', ...props }: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg viewBox='0 0 14.656 15' width={14.656} {...props}>
      <path
        d='M14.667 5.9a.919.919 0 00-.87-.926h-4.2L8.19.656a.9.9 0 00-1.746.068L5.057 4.975H.91a.919.919 0 00-.91.929.933.933 0 00.321.7L3.853 9.38l-1.315 4.3a.942.942 0 00-.086.388.92.92 0 00.91.929.892.892 0 00.547-.191.013.013 0 00.006 0l3.427-2.687 3.307 2.6a.893.893 0 00.646.277.919.919 0 00.909-.929.907.907 0 00-.059-.318h.007l-1.331-4.353 3.48-2.75a.931.931 0 00.366-.746z'
        fill={fill}
        fillRule='evenodd'
      />
    </svg>
  );
}

export default SvgFullStar;
